import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { BeachWatchGoogleMapComponent } from './beach-watch-google-map/beach-watch-google-map.component';
import { MapsSectionComponent } from './maps-section/maps-section.component';
import { SiteLinkComponent } from './site-link/site-link.component';

import { GoogleMapsModule } from '@angular/google-maps';
import { GooglemapsWrapperModule } from '../googlemaps-wrapper/googlemaps-wrapper.module';

import { SiteMarkerComponent } from './site-marker/site-marker.component';
import { BeachsitesListService } from './beachsites-list-service';
import { RouterModule } from '@angular/router';
import { SitesService } from '../services/sites.service';
import { SiteDetailsModule } from '../site-details/site-details.module';

import { MapLegendComponent } from './map-legend/map-legend.component';
import { CurrentLocationComponent } from './current-location/current-location.component';
import { ZoomToSearchResultService } from './ZoomToSearchResultService';
import { SiteWeatherForecastComponent } from './site-weather-forecast/site-weather-forecast.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // import the FormsModule
import { SharedCompsModule } from '../shared/shared-comps.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { GMapInfoWindowComponent } from './gmap-info-window/gmap-info-window.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterResultsSideNavComponent } from './filter-results-side-nav/filter-results-side-nav.component'
import { MatSidenavModule } from '@angular/material/sidenav';
import { AppMonitoringService } from '../services/logging.service';

@NgModule({
	declarations: [
		BeachWatchGoogleMapComponent, 
		MapsSectionComponent, 
		SiteLinkComponent, 		 
		SiteMarkerComponent,
		MapLegendComponent,
		CurrentLocationComponent,
		SiteWeatherForecastComponent,
  		GMapInfoWindowComponent,
    	FilterResultsSideNavComponent     
	],
	imports: [
		CommonModule,		
		HttpClientModule,
		HttpClientJsonpModule,
		GoogleMapsModule,
		RouterModule,
		SiteDetailsModule,
		SharedCompsModule,		
		ReactiveFormsModule,
		FormsModule, 
		OverlayModule,
		MatTooltipModule,
		MatSidenavModule		
	],
	exports: [MapsSectionComponent],
	providers : [BeachsitesListService, SitesService, ZoomToSearchResultService,AppMonitoringService]	
})
export class BeachWatchMapModule {}
